const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the add Duration component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Categories} Categories injected to gain access to the Categories resource
 */
app.directive('addDuration', [function () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        content: '=',
        noChange: '=',
        onChange: '&?'
      },
      template: require('../../../templates/directives/cms/add-duration.html'),
      controller: ['$scope', function ($scope) {
        var self = this;

        self.initialize = function() {
          contentWatch();

          if (!$scope.content.duration) {
            self.hours = 0;
            self.minutes = 0;
            setWatches();
            return;
          }
          self.hours = Math.floor($scope.content.duration / 3600);
          self.minutes = Math.floor(($scope.content.duration - (self.hours * 3600)) / 60);
          setWatches();
        };

        var resetDuration = function() {
          $scope.content.duration = self.hours * 3600 + self.minutes * 60;
          if ($scope.onChange) {
            $scope.onChange();
          }
        };

        var setWatches = function() {
          var items = ['duration.hours', 'duration.minutes'];
          angular.forEach(items, function(item) {
            $scope.$watch(item, function(newVal, oldVal) {
              if (newVal && newVal !== oldVal || newVal === 0 && newVal !== oldVal) {
                resetDuration();
              }
            });
          });
          $scope.$watch('content.duration', function(newVal, oldVal) {
            if ($scope.content.duration) {
              self.hours = Math.floor($scope.content.duration / 3600);
              self.minutes = Math.floor(($scope.content.duration - (self.hours * 3600)) / 60);
            }
          });
        };

        var contentWatch = $scope.$watch('content', function(newVal, oldVal) {
          if (!newVal || newVal === oldVal) {
            return;
          }
          self.initialize();
        });

        if ($scope.content) {
          self.initialize();
        }
      }],
      controllerAs: 'duration'
    };
  }]);
